export enum Collection {
	BON_LIVRAISON = "bons-livraisons",
	DEPOT = "depots",
	DOCUMENT_HISTORIQUE = "documents-historiques",
	DOCUMENT_VERROU = "documents-verrous",
	DEMANDE = "demandes",
	ARTICLE = "articles",
	UTILISATEUR = "users",
	PROJET = "projets",
	FOURNISSEUR = "fournisseurs",
	BON_COMMANDE = "bons-commandes",
	CLIENT = "Clients",
	DECOMPTE = "decomptes",
	ATTACHMENT = "attachements",
	AVENANT = "avenants",
	FACTURE = "factures",
	CAUTION = "cautions",
	PAIEMENT = "paiements",
	SOUS_PROJET = "sous-projets",
	DEVIS = "devis",
	CONSULTATION = "consultations",
	CHARGE = "charges",
	SUIVIE_LOGISTIQUE = "fiches-logistiques",
	ENGINS = "engins",
	CHAUFFEURS = "chauffeurs",
	KILOMETRAGES = "kilometrages",
	DASHBOARD = "dashboard",
	//Timesheet related collections
	TIMESHEET = "feuille-de-temps",
	ENTREE_PROJETS = "entrees-projets",
	TACHES = "taches",
	CATEGORIE_TACHES = "categorie-taches",
	EMPLOYE = "employes",
	//RH
	DEMANDE_STC = "demande-stcs",
	DEMANDE_RECONNAISSANCE_DETTE = "demande-reconnaissance-dettes",
	DEMANDE_CONGE = "demande-conges",
	DEMANDE_DOMICILIATION = "demande-domiciliation-salaires",
	DEMANDE_AVERTISSEMENT = "demande-avertissements",
	NOTE_FRAIS = "notes-frais",
	LIGNE_FRAIS = "lignes-frais",
	DEMANDE_ATTESTATION_SALAIRE = "demande-attestation-salaires",
	DEMANDE_ATTESTATION_TRAVAIL = "demande-attestation-travails",
	DEMANDE_BULLETIN_PAIE = "demande-bulletin-paies",

	INTERMAIRE = "interimaires",
	AGENCE_INTERIM = "agence-interimaires",
	CONTRAT = "contrats",
	DOCUMENT_INTERIMAIRE = "document-interimaires",
	//Pointage
	POINTAGE = "pointages",
	TYPE_NOTE_PROFESSIONNELLE = "type-note-professionnelles",
	//Finance
	DEMANDE_PAIEMENT = "demande-paiements",
	DEMANDE_PRESTATION = "demande-prestations",
	CATEGORIE_PROPOSITION_PAIEMENTS = "categorie-proposition-paiements",
	PAIEMENT_PROPOSITION_PAIEMENTS = "paiement-demande-paiements",
	DEMANDE_PAIEMENT_LIGNE_PROJETS = "demande-paiement-ligne-projets",
	DEMANDE_PAIEMENT_LIGNE_FACTURES = "demande-paiement-ligne-factures",
	DEMANDE_PAIEMENT_LIGNE_BANQUES = "demande-paiement-ligne-banques",
	DEMANDE_PAIEMENT_LIGNE_TVAS = "demande-paiement-ligne-tvas",
	FACTURE_FOURNISSEUR = "factures-fournisseurs",
	TAUX = "tauxes",
	BANQUE_EMETTRICE = "banques-emettrices",
	//Loyers
	BAILLEUR = "bailleurs",
	BAIL = "bails",
	ECHEANCE_LOYER = "echeance-loyers",
	ECHEANCE_CHARGE = "echeance-charges",
	DEMANDE_LOCATION = "demande-locations",
	//Budget - charges fixes
	CHARGE_VEHICULE = "charge-vehicules",
	CHARGE_MUTUELLE = "charge-mutuelles",
	CHARGE_ABONNEMENT_TELEPHONIQUE = "charge-abonnement-telephoniques",
	CHARGE_ASSURANCE = "charge-assurances",
	//Budget - charges variables
	CHARGE_TELEPHONE = "charge-telephones",
	CHARGE_ELECTRICITE = "charge-electricites",
	CHARGE_CARBURANT = "charge-carburants",
	CHARGE_HONORAIRE = "charge-honoraires",
	BUDGET_RECAP = "budget/recap",
	//Importation
	DOSSIER_IMPORTATION = "dossier-importations",
	DOSSIER_IMPORTATION_PAIEMENT = "dossier-importation-paiements",
	PARAMETRE = "parametre",
}
